export const KEYBOARD_CODES = {
  ENTER: 13,
  TAB: 9
};
